export default {
  title: {
    en: 'LET’S GET BACK TOGETHER',
  },
  text: {
    en: `
    Having second thoughts? Just remember: to keep discovering new scents,
    you can always adjust frequency to skip months, add on products as you go,
    and cancel again anytime.
  `,
  },
  btnResubscribe: {
    en: 'Resubscribe me',
  },
  btnResubscribeAndChangeFrequency: {
    en: 'Resubscribe & change frequency',
  },
  btnNotYet: {
    en: 'Not yet',
  },
}
